<div class="country-switcher">
  <button class="country-switcher__cta" (click)="toggleMenu()">
    <img src="/au/giftcards/assets/flag-au.svg" width="24" />
  </button>

  <nav class="country-switcher__nav" [class.active]="isMenuActive">
    <button class="country-switcher__cta country-switcher__cta--back" (click)="toggleMenu()">
      Back
    </button>
    <p class="country-switcher__nav-label">Select your country or region</p>
    <ul class="country-switcher__nav-list" [class.active]="isMenuActive">
      <li
        *ngFor="let country of countryItems; index as i"
        class="country-switcher__nav-list-item"
        [class.active]="isMenuActive"
        [style.--index]="i"
      >
        <a class="country-switcher__link" [class.active]="country.isCurrent" [href]="country.link">
          <img
            class="country-switcher__link--flag"
            [src]="country.iconSrc"
            [alt]="'Flag of ' + country.label"
            width="24"
          />
          <span class="country-switcher__link--label">{{ country.label }}</span>
          <img
            *ngIf="country.isCurrent"
            class="country-switcher__link--checkmark"
            src="/au/giftcards/assets/checkmark.svg"
            width="18"
          />
        </a>
      </li>
    </ul>
  </nav>
</div>
